import React from "react";
import { Button } from "react-bootstrap";
import {
  Annotation,
  getAnnotationLabel,
} from "../utils/annotator/annotationsHelper";
import PreviewQuote from "./PreviewQuote";

interface DeleteAnnotationConfirmFormProps {
  /** Annotation being deleted; used to infer the label in the prompt. */
  annotation: Annotation;
  /** Invoked when the user confirms the delete. */
  onConfirm: () => void;
  /** Invoked when the user backs out. */
  onCancel: () => void;
}

/**
 * The delete-confirmation form body for all annotation types
 */
function DeleteAnnotationConfirmForm({
  annotation,
  onConfirm,
  onCancel,
}: DeleteAnnotationConfirmFormProps) {
  const itemKind = getAnnotationLabel(annotation.type);
  return (
    <>
      <PreviewQuote text={annotation.text} />
      <p>
        <strong>
          Are you sure you want to permanently delete this&nbsp;
          {itemKind.toLowerCase()}?
        </strong>
      </p>
      <hr aria-hidden="true" className="w-100" />
      <div className="d-flex justify-content-end">
        <Button variant="outline-secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" className="ml-2" onClick={onConfirm}>
          Delete
        </Button>
      </div>
    </>
  );
}

export default DeleteAnnotationConfirmForm;
